'use strict';

module Patersons {

    export class InvestorDocsComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/portfolioSummary/components/investorDocs.component.html';
        controller: any = InvestorDocsController;
        bindings: any = {
            report: '<',
            isDownloading: '<',
            onDownloadFiles: '&'
        };
    }

    export class InvestorDocsController{

        report: any;
        reverse: boolean;
        predicate: string;
        isSelectAll: boolean;
        isDownloading: boolean;
        onDownloadFiles;
        constructor() {


            this.predicate = "date";
            this.reverse = true;
            var self = this;
            this.report.investorDocs = this.report.investorDocs.map(function(a){
                a.date = self.extractDateFromString(a.name);
                return a;
            })
        }
        extractDateFromString = function(string){
            var months = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
            // Match = 12 January 2019
            var regexpFullDate = new RegExp("\\d{1,2} ("+ months.join("|") +") \\d{4}", "gi");
            var matchFullDate = string.match(regexpFullDate);
            // Match 2019'20
            var regexpYear = new RegExp("\\d{4}'\\d{2}");
            var matchYear = string.match(regexpYear);
            // Match September 2019
            var regexpPartialDate = new RegExp("(" + months.join("|") + ") \\d{4}", "gi");
            var matchPartialDate = string.match(regexpPartialDate);

            var date = null;
            if (matchFullDate && matchFullDate[0]){
                date = new Date(matchFullDate[0]);
            } else if (matchYear && matchYear[0]){
                var yearSplit = matchYear[0].split("'");
                var year = parseInt(yearSplit[0]) + 1
                date = new Date(year.toString());
            } else if (matchPartialDate && matchPartialDate[0]){
                var dateSplit = matchPartialDate[0].split(" ");
                date = new Date(dateSplit[1], months.indexOf(dateSplit[0].toLowerCase()), 1);
            }
            return date;
        };
        selectAll = function (check) {

            this.report.investorDocs.forEach(function (item, index) {
                item.isSelected = check;
            });

        };

        order = function (predicate) {
            this.reverse = (this.predicate === predicate) ? !this.reverse : false;
            this.predicate = predicate;

        };

        downloadDocs = function ()
        {
            let selectedItems = [];
            this.report.investorDocs.forEach(function (item, index) {
                if (item.isSelected) {
                    selectedItems.push(item)
                }
            });

            this.onDownloadFiles({ investorDocs: selectedItems })
        }
    }

}

